import { isUrl } from '../../utils/formatter'

export const validate = (name, url) => {
	return (isUrl(url) || isUrl('http://' + url)) && name.length > 0
}
